// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./FormLabel.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  SpacerPrimitive,
  TextPrimitive,
  ContainerPrimitive,
} from "../_internal_primitives";
import { FormLabelRoot } from "../_internal_formlabel";

const styles = [
  {
    type: "default",
    layers: {
      "formlabel-text": {
        none: {
          text: "Label",
        },
      },
      JMt6mYUZib: {
        none: {
          text: "Descriptive text.",
        },
      },
    },
  },
  {
    type: "enum",
    propName: "labelPosition",
    values: [
      {
        propValue: "top",
        layers: {},
      },
      {
        propValue: "right",
        layers: {},
      },
      {
        propValue: "bottom",
        layers: {},
      },
      {
        propValue: "left",
        layers: {},
      },
    ],
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "labelPosition",
    values: [
      {
        propValue: "top",
        layers: {},
      },
      {
        propValue: "right",
        layers: {},
      },
      {
        propValue: "bottom",
        layers: {},
      },
      {
        propValue: "left",
        layers: {},
      },
    ],
  },
];

const variantPropTypes = [
  {
    type: "enum",
    propName: "labelPosition",
    propValues: ["top", "right", "bottom", "left"],
  },
];

export const FormLabelContext = createContext(null);

function FormLabel(_props) {
  const defaults = useContext(FormLabelContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <FormLabelRoot
      {...props}
      key="formlabel-root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "formlabel-root",
        scope: "CW4jwXTZxa",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <ContainerPrimitive
            id={"Container_KBs5PXJv7E"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_CW4jwXTZxa_KBs5PXJv7E"
            }
            key={"KBs5PXJv7E"}
            addSpacing={false}
            element={getStyle("KBs5PXJv7E", "htmlElement")}
          >
            <TextPrimitive
              id={"text_formlabel-text"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_CW4jwXTZxa_formlabel-text"
              }
              key={"formlabel-text"}
              text={props.label}
              element={getStyle("formlabel-text", "htmlElement")}
            />
            <SpacerPrimitive
              id={"subSpace_FZSpGB4roM"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_CW4jwXTZxa_FZSpGB4roM"
              }
              key={"FZSpGB4roM"}
            />
            <TextPrimitive
              id={"Subheader_JMt6mYUZib"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_CW4jwXTZxa_JMt6mYUZib"
              }
              key={"JMt6mYUZib"}
              text={props.label}
              element={getStyle("JMt6mYUZib", "htmlElement")}
            />
            <SpacerPrimitive
              id={"formspace_63GVYcDVF1"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_CW4jwXTZxa_63GVYcDVF1"
              }
              key={"63GVYcDVF1"}
            />
          </ContainerPrimitive>
          <ContainerPrimitive
            key={"formlabel-slot"}
            id={"slot_formlabel-slot"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_CW4jwXTZxa_formlabel-slot"
            }
            addSpacing={false}
          >
            {props.control}
          </ContainerPrimitive>
        </>
      )}
    </FormLabelRoot>
  );
}

FormLabel.__variants = [
  {
    name: "labelPosition",
    type: "group",
    variants: ["top", "right", "bottom", "left"],
  },
];

export default FormLabel;
